import React, { useEffect, useState, forwardRef, Ref } from 'react';
import {update_facilitydetails} from './../../../constants'
import axios from '../../../utils/axiosExt';
import endpoints from '../../../config/endpoints';
import HealthFacilityViewUi from './HealthFacilityViewUi';
import HealthFacilityUpdateUi, { ChildComponentHandlerUpdate }  from './HealthFacilityUpdateUi';
import HealthFacilityUpgradeUi, { ChildComponentHandlerUpgrade } from './HealthFacilityUpgradeUi';
import Auth from '../../../utils/auth';
import { errorLogger } from '@utils/applicationLogUtils';

interface propType {
  facility: any;
  flow: string;
  ref1: Ref<ChildComponentHandlerUpgrade>;
  ref2: Ref<ChildComponentHandlerUpdate>;
}

interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?:any,
  verifiedDetails?:any
}

interface formStateType {
  [key: string]: objectType
}

interface formDataType {
  [key: string]: any;
}

const HealthFacilityOverView = forwardRef((props: propType, ref: Ref<any>) => {
  const { facility, flow } = props;
  
    const [facilityDetailsFormData, setFacilityDetailsFormData] = useState<any>(update_facilitydetails);

    const [facilityDetailsFormState, setFacilityDetailsFormState] = useState<formStateType>({
      facility_name: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
      },
    facility_category: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    ownership: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    hpr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      verifiedDetails:''
    },
    administrative_body: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    central_govt_dept: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    rural_urban: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
   });

     // FacilityDetailsFormChange
  const handleFacilityDetailsFormChange = (value: string | boolean, key: string, id: formDataType) => {
    setFacilityDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id:id
      },
    }));  
  };

  useEffect(()=>{
    const fetchFacilityCategoryType = async()=>{
      try{
        if (facilityDetailsFormState?.facility_type?.id && facilityDetailsFormState?.rural_urban?.id) {
         
       const facility_categoryResponse = await axios.get(`${endpoints.getFacilityCatByFacilityTypeIdRuralOrUrban(facilityDetailsFormState.facility_type.id,facilityDetailsFormState.rural_urban.id)}`, Auth.loggedIn());
       const facility_category_options = facility_categoryResponse.data.data.map((key: any) => ({
        value: key.facility_category,
        label: key.facility_category,
        id: key.facility_category_id,
        }));
        const facility_typeResponse = await axios.get(endpoints.getFacilityType, Auth.loggedIn());
        const facility_type_options = facility_typeResponse.data.data.map((key: any) => ({
          value: key.facility_type,
          label: key.facility_type,
          id:key.facility_type_id
        }));
        setFacilityDetailsFormData((create_facilitydetails: { facility_category: any; facility_type: any; ownership:any;})=>({
          ...create_facilitydetails,
          facility_category:{
            ...create_facilitydetails.facility_category,
            '#options': facility_category_options,
          },
          facility_type:{
            ...create_facilitydetails.facility_type,
            '#options': facility_type_options,
          },
          
        }))
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          ownership: {
            ...facilityDetailsFormState.ownership,
            value: '',
          },
        }));  
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          administrative_body: {
            ...facilityDetailsFormState.administrative_body,
            value: '',
          },
        }));  
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,  
          central_govt_dept: {
            ...facilityDetailsFormState.central_govt_dept,
            value: '',
          },
        }));

        }

      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
      }
    };
    fetchFacilityCategoryType();
  },[facilityDetailsFormState.facility_type.id]);
  
  if(flow ==='view'){
    return <HealthFacilityViewUi facility={facility} flow={flow}/>
  } else if(flow ==='update'){

    if(facility.facility_status==='Permanently Closed'){

      return <HealthFacilityViewUi facility={facility} flow={flow}/>

    } else {

      return <HealthFacilityUpdateUi facility={facility} ref={props.ref2} handleFormChange={handleFacilityDetailsFormChange} formState={facilityDetailsFormState} formData={facilityDetailsFormState} user={facility} flow={flow}/>

    }
      
  } else {
    
    if(facility.facility_status==='Permanently Closed'){

      return <HealthFacilityViewUi facility={facility} flow={flow}/>

    } else {

      return <HealthFacilityUpgradeUi facility={facility} ref={props.ref1} handleFormChange={handleFacilityDetailsFormChange} formState={facilityDetailsFormState} formData={facilityDetailsFormData} user={facility} flow={flow}/>

    }
  }
});
HealthFacilityOverView.displayName = 'HealthFacilityOverView';

export default HealthFacilityOverView;
